module.exports = __webpack_public_path__ + "img/fire.79f0e049.png";